import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import {
  DataBindingDirective,
  GridComponent,
  GridDataResult,
  PageChangeEvent,
} from '@progress/kendo-angular-grid';
import { ItemsService } from '@progress/kendo-angular-menu';
import { FilterDescriptor, orderBy, process, State } from '@progress/kendo-data-query';
import { map } from '@progress/kendo-data-query/dist/npm/transducers';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable } from 'rxjs';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import {
  CheckboxMaster, IItemList,
  ISearchItemResultPageResource,
  IFilterItemRequest, CartItem, MasterData, IApiResultResponse, IMasterData, ItemSearchCritera, IAdvanceSearchLbl
} from 'src/app/core/models';
import { ApiService } from 'src/app/core/services/api.service';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { CartService } from 'src/app/core/services/cart.service';
import { ItemService } from 'src/app/core/services/item.service';
import { MasterDataService } from 'src/app/core/services/master-data.service';
import { PriceBookService } from 'src/app/core/services/price-book.service';
import { Info } from '../../core/common';
import { QuoteService } from '../../core/services/quote.service';
import { UserService } from '../../core/services/user.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { cloneDeep } from 'lodash';
import { LanguageTranslationService } from '../../core/services/language-translation.service';
import { V6productService } from '../../core/services/v6product.service';
declare var $: any;
@Component({
  selector: 'app-advance-search',
  templateUrl: './advance-search.component.html',
  styleUrls: ['./advance-search.component.scss'],
})
export class AdvanceSearchComponent implements OnInit {
  advanceSearchTxt: IAdvanceSearchLbl;
  expanded: boolean;

  constructor(private formBuilder: FormBuilder, private appNotifyService: AppNotifyService,
    private cartService: CartService,
    private itemService: ItemService,
    private router: Router,
    private priceBookService: PriceBookService,
    private masterService: MasterDataService,
    private quoteService: QuoteService,
    private userService: UserService, private languageTranslationService: LanguageTranslationService, private viewportScroller: ViewportScroller,
    private v6productService: V6productService

  ) { }
  pageTitle = 'Advanced Search';
  public selectAllCategory = true;
  public selectAllFinish = true;
  public advanceSearchLoading: boolean;
  public it: any = [];
  public itemFinishtest = [];
  public gridState: State = {
    sort: [
      {
        field: 'itemNumber',
        dir: 'asc',
      },
    ],
    skip: 0,
    take: 10,
    group: [],
    // filter: {},
  };

  imageURL: string;

  public priceBookCategories: CheckboxMaster[];
  public itemFinishes: CheckboxMaster[];
  public itemList: IItemList[];
  public searchResult: ISearchItemResultPageResource;
  public totalRecords = 0;
  public pageSize = 10;
  public currentPage = 0;
  public gridView: GridDataResult;
  public tileView: GridDataResult = { data: [], total: 0 };

  public skip = 0;
  protected decimals = 0;
  protected autoCorrect = true;

  public noRecordFound = false;
  public showGridView = true;
  public showTilesView = false;
  public showImgGrid = true;


  //paint
  public paintValue = [];
  public paintValue1 = [];
  public showPaint: boolean = false;

  totalPageSizes = [10, 50, 75, 100];
  p = 1;
  itemsPerPage = 10;
  totalItems: any;
  isTileView = false;

  private filterItemRequestPayload: IFilterItemRequest = {
    customerNumber: '',
    itemNumber: '',
    longItemNumber: '',
    pageNo: 1,
    searchQuery: '',
    skip: 0,
    take: 10,
    finishFilter: [],
    categoryFilter: [],
    sort: [
      {
        field: '',
        dir: 'asc',
      },
    ],
    filter: [{ field: 'itemNumber', operator: 'contains', value: '' }]
  };

  public unCheckedFinish: string[] = [];
  public unCheckedCat: string[] = [];
  public checkedCat: number[] = [];
  public checkedFin: string[] = [];
  showViewPopup: boolean;
  addQuoteForm: FormGroup;
  //#region event handlers

  //#region grid Sorting & filtering
  filters: { field: string, value: string }[] = [];

  // ngx pagination
  // this function handles the next and previous  button click

  handlePaintChange(event, dataItem) {
    dataItem.selectedPaint = event.value;
  }
  handlePaintFilter(event) {
    this.paintValue = this.paintValue1.filter(
      (s) => s.name.toLowerCase().indexOf(event.toLowerCase()) !== -1
    );
  }
  // written for changing the grid view to tile view and vice versa.
  listBtnClick(val) {
    this.isTileView = false;
    this.totalRecords = 0;
    this.pageSize = 10;
    this.currentPage = 1;
    this.skip = 0;
    if (val == 'grid') {      // to show the default grid view
      this.showImgGrid = true;
      this.showGridView = true;
      this.showTilesView = false;
    } else if (val == 'tile') { // to show the tile view
      this.showTilesView = true;
      this.showGridView = false;
      this.isTileView = true;
      this.totalPageSizes = [10, 50, 75, 100];  // reset the pagination
      this.p = 1;
      this.itemsPerPage = 10;
    } else if (val == 'noImg') {    // to show the tile view
      this.showImgGrid = false;
      this.showTilesView = false;
      this.showGridView = true;
    }
    this.filterItemRequestPayload.skip = 0;
    this.filterItemRequestPayload.take = 10;
    this.loadItems();   // loading the grid items
  }

  // to show the link to open grid view or list view
  public onToggleView(): void {
    this.showViewPopup = !this.showViewPopup;
  }
  //to show commonly order items 
  showCommonlyOrderedItems: boolean;
  commonlyOrderDataList: any;
  public commonlyOrderItems(item): void {
    this.commonlyOrderDataList = [];
    this.showCommonlyOrderedItems = false;
    const body = {
      itemNumber: item.itemNumber
    }
    this.itemService.getCommonlyOrderedItems(body).subscribe(response => {
      console.log(response);
      if (response.length > 0) {
        this.commonlyOrderDataList = response;
        this.showCommonlyOrderedItems = true;
      } else {
        this.appNotifyService.notify(NotifyType.INFO, "No records available!");
      }
      
    })
  }
  closeCommonlyOrderDialog() {
    this.showCommonlyOrderedItems = false;
    this.commonlyOrderDataList = [];
  }
  public getAssociateItem(item): void {
    this.showCommonlyOrderedItems = false;
    //this.selectAllCategory
    this.checkedCat = [];
    // this.selectAllFinish
    this.checkedFin = [];
    //this.filterItemRequestPayload.sort = this.gridState.sort;
    this.filters = [];
    // this.filterItemRequestPayload.customerNumber = this.userService.loggedInUser.customerNumber;

    this.filterItemRequestPayload.itemNumber = item.associatedItemNumber;
    this.loadItems();


  }

  //selectedCategory: number = -1;
  //showSuggestionBox: boolean;
  //selectedItem = '';
  //public searchForm: FormGroup = new FormGroup({
  //  selectedCategory: new FormControl(-1),
  //  selectedItem: new FormControl(''),
  //});
  //QAIssue for advance button
  resetSearch() {
    this.itemService.searchCriteria = new ItemSearchCritera();
    //this.selectedCategory = -1;
    //this.selectedItem = '';  
    //this.searchForm.controls.selectedCategory.reset();
    //this.searchForm.controls.selectedItem.reset();
    this.itemService.ResetSearchForm.next(true);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/advanced-search']); // navigate to same route
    });
  }

  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "defaultViewLbl" },
      { controlName: "tileViewLbl" },
      { controlName: "listViewLbl" },
      { controlName: "finishLowercaseLbl" },
      { controlName: "imageLbl" },
      { controlName: "paintLbl" },
      { controlName: "sizeLbl" },
      { controlName: "paintLbl" },
      { controlName: "sizeLbl" },
      { controlName: "quantityLbl" },
      { controlName: "descriptionLbl" },
      { controlName: "itemLbl" },
      { controlName: "listPriceLbl" },
      { controlName: "selectionLbl" },
      { controlName: "addToCartLbl" },
      { controlName: "build" },
      { controlName: "categoryLbl" },
      { controlName: "finishUppercaseLbl" },
      { controlName: "tileNoRecordLbl" },
      { controlName: "priceLbl" },
      { controlName: "tileItemPerPageLbl" },
      { controlName: "ofLbl" },
      { controlName: "itemsLbl" },
      { controlName: "clearSearchLbl" },
    ];
    const componentName = "advanceSearch";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.advanceSearchTxt = response[response.length - 1];
      console.log(response);
    }
  }

  //#endregion
  //#region label declaration
  protected advanceSearch = {
    defaultViewLbl: 'Default',
    tileViewLbl: 'Tile',
    listViewLbl: 'List',
    finishLowercaseLbl: 'Finish',
    imageLbl: 'Image',
    paintLbl: 'Paint',
    sizeLbl: 'Size',
    quantityLbl: 'Quantity',//'Qty',
    descriptionLbl: 'Description',
    itemLbl: 'Item #',
    listPriceLbl: 'List price',
    selectionLbl: 'Selection',
    addToCartLbl: 'Add To Cart',
    addToQuoteLbl: 'Add To Quote',
    buildLbl: 'Build',
    categoryLbl: 'CATEGORY',
    finishUppercaseLbl: 'FINISH',
    selectAllLbl: 'Select All',
    tileNoRecordLbl: 'No records available.',
    priceLbl: 'Price',
    tileItemPerPageLbl: 'Items per Page',
    ofLbl: 'of',
    itemsLbl: 'items',
    clearSearchLbl: "Clear Search"
  }
  //#endregion
  private loadItems(): void {
    // console.log("hello");
    this.advanceSearchLoading = true;
    //set initial value to load the 
    this.filterItemRequestPayload.categoryFilter = this.selectAllCategory ? [] : this.checkedCat;
    this.filterItemRequestPayload.finishFilter = this.selectAllFinish ? [] : this.checkedFin;
    this.filterItemRequestPayload.sort = this.gridState.sort;
    this.filterItemRequestPayload.filter = this.filters;
    this.filterItemRequestPayload.customerNumber = this.userService.readUserObject.customerNumber;
    this.itemService.filterItems(this.filterItemRequestPayload as IFilterItemRequest)
      .subscribe(data => {
        // data will be in this format {isError,data, erroMessage}        
        data.currentPageData.forEach(d => {
          if (d.availableFinish.length == 0) {
            d.listPriceFormated = d.listPrice;
          }
        });
        if (!this.isTileView) {     // condition written for data binding to the default grid and tile view seperately
          //console.log(this.gridState.sort);
          this.gridView = {
            data: data.currentPageData, // orderBy(data.currentPageData, this.gridState.sort),
            total: data.totalRecords
          };
        } else if (this.isTileView) {
          this.tileView = {
            data: data.currentPageData,
            total: data.totalRecords
          };
          this.totalItems = this.tileView.total; // added for binding totals in tiles view pagination
          if (data.currentPageData.length > 0) {    // added empty check condition
            this.noRecordFound = false;
          } else {
            this.noRecordFound = true;
          }
        }
        this.advanceSearchLoading = false;
      });
  }

  async ngOnInit() {
    this.loadLanguageTranslationData();
    this.imageURL = environment.imageBaseUrl + environment.imageFolder;
    this.addQuoteForm = this.formBuilder.group({
      itemId: new FormControl(),
      quote: new FormControl(),
      jobName: new FormControl(),
      marketSegment: new FormControl(),
      leed: new FormControl(false)
    });
    // load data, show api
    this.advanceSearchLoading = true;
    //set initial filters to load the item list    
    if (this.itemService.searchCriteria.itemNumber.length === 0) { this.filterItemRequestPayload.searchQuery = this.itemService.searchCriteria.searchQuery; }
    else { this.filterItemRequestPayload.searchQuery = ''; }
    this.filterItemRequestPayload.itemNumber = this.itemService.searchCriteria.itemNumber;
    if (this.itemService.searchCriteria.categoryId > 0) {
      this.checkedCat.push(this.itemService.searchCriteria.categoryId);
      this.selectAllCategory = false;
      this.loadItems();
    }
    else {
      //this.checkedCat = cloneDeep(this.itemService.searchCriteria.allCategoryIds);
      this.selectAllCategory = true;
    }
    this.selectAllFinish = true;//default load
    //this.loadItems();
    // load grid data based on the search from api   
    this.paintValue = this.masterService.getPaintValues();
    this.paintValue1 = this.masterService.getPaintValues();
    // init category filter
    this.masterService.getPriceBookCategories().then(r => {
      this.priceBookCategories = r;
      if (!(this.itemService.searchCriteria.categoryId > 0)) {
        this.priceBookCategories.forEach((el, i) => { this.checkedCat.push(+el.value) });
        this.loadItems();
      }//set initial value
      this.setCategoryFilter();
    });
    this.masterService.getFinishes().then(r => {
      this.itemFinishes = r;
      this.itemFinishes.forEach((el, i) => { this.checkedFin.push(el.value) });//set initial value
      this.setFinishFilters();
    });
    // reset categoryId for search 
    //this.filterItemRequestPayload.searchQuery = '';
    
  }




  //#region grid & tile view  Sorting, filtering & paging
  onFilter(event, field) {
    const value = event.target.value ? event.target.value.trim().toUpperCase() : '';
    const temp = this.filters.find(x => x.field === field);
    if (temp) {
      if (value.length > 0) {
        temp.value = value;
      } else {
        // remove entry
        this.filters.splice(this.filters.findIndex(x => x.field === field), 1);
      }
    } else {
      if (value.length > 0) {// apply trim
        this.filters.push({ field, value });
      }
    }
    //console.log(this.filters);
    this.loadItems();
  }
  applyFilter(event, field) {
    //console.log(event, field);
  }
  gridSortChange(event): void {
    // this.g
    this.gridState.sort = event;
    // console.log(this.gridState.sort);
    this.loadItems();
  }
  handlePageChange(page) {
    let skipCount = (page - 1) * this.itemsPerPage;
    this.filterItemRequestPayload.skip = skipCount;
    this.filterItemRequestPayload.take = this.itemsPerPage;
    this.isTileView = true;  // making this as true to load data in tile view
    this.loadItems();
  }
  // this handles the pagesize dropdown
  handlePageSizeChange(event) {
    this.p = 1;
    this.itemsPerPage = parseInt(event.target.value);
    this.filterItemRequestPayload.skip = 0;
    this.filterItemRequestPayload.take = this.itemsPerPage;
    this.isTileView = true;     // making this as true to load data in tile view
    this.loadItems();
  }

  public pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
    this.filterItemRequestPayload.skip = skip;
    this.filterItemRequestPayload.take = take;
    this.loadItems();
  }
  //#endregion
  //#region event handlers
  //#region primary buttons
  isCartItemValid(cartItem: CartItem, item: any): boolean {
    let isValid = true;
    if (cartItem) {
      if (cartItem.finishValue) {
        item.isInavlidFinishValue = false as boolean;
      } else {
        item.isInavlidFinishValue = true as boolean;
        // this.appNotifyService.notify(NotifyType.ERROR, "Please select valid finish!!!");
        isValid = false;
      }

      // if (cartItem.finish) {
      //  item.isInavlidFinishValue = false as boolean;
      // }
      // else {
      //  item.isInavlidFinishValue = true as boolean;
      //  this.appNotifyService.notify(NotifyType.ERROR, "Please select valid finish!!!");
      //  isvalid = false;
      // }

      if (cartItem.size) {
        item.isInavlidSize = false as boolean;
      } else {
        item.isInavlidSize = true as boolean;
        // this.appNotifyService.notify(NotifyType.ERROR, "Please select valid extrusion!!!");
        isValid = false;
      }

      if (cartItem.quantity) {
        item.isInavlidQuantity = false as boolean;
      } else {
        item.isInavlidQuantity = true as boolean;
        // this.appNotifyService.notify(NotifyType.ERROR, "Please select valid quantity!!!");
        isValid = false;
      }

    } else {
      return false;
    }
    return isValid;
  }
  addStockItemToCart(item: any) {
    // map data for transport
    // should show a loading indicator somewhere
    //checking validation
    const cartItem = this.validateAndPrepareModel(item);
    //console.log(item);
    if (cartItem && cartItem.isValid) {
      // all ok
      var longItemNumber = cartItem.itemNumber;// + '-' + cartItem.finishValue + '-' + cartItem.size;
      longItemNumber = (cartItem.finishValue && cartItem.finishValue.length > 0) ? longItemNumber + '-' + cartItem.finishValue : longItemNumber;
      longItemNumber = (cartItem.size && cartItem.size.length > 0) ? longItemNumber + '-' + cartItem.size : longItemNumber;
      cartItem.longItemNumber = longItemNumber;
      this.cartService.addStockItem(cartItem).subscribe(r => {
        // const currentCount = this.cartService.totalCartItem.value;
        //console.log(r);
        this.cartService.totalCartItem.next(r.cartItemCount);
        this.appNotifyService.notify(NotifyType.SUCCESS, 'Item has been added to the Cart!');
      }, error => {
        this.appNotifyService.notify(NotifyType.ERROR, 'Sorry an error occured. Please try again!');
      });
      // notify navbar component to update the cart item count.
    }
  }
  //checking validation before adding item to cart/quote
  validateAndPrepareModel(item) {
    const cartItem = new CartItem();
    cartItem.itemNumber = item.itemNumber;
    item.isInavlidFinishValue = false as boolean;
    item.isInavlidSize = false as boolean;
    item.isInavlidQuantity = false as boolean;
    item.isEmptyPaint = false as boolean;
    if (item.availableFinish && item.availableFinish.length > 0) {
      if (!item.selectedFinish) { item.isInavlidFinishValue = true as boolean; cartItem.isValid = false; return; }
      //checking validation for paint code if finish is 22
      if (item.selectedFinish === '22') {
        if (!item.selectedPaint) {
          item.isEmptyPaint = true as boolean;
          cartItem.isValid = false;
          return;
        }
      }
      if (item.selectedPaint) {
        cartItem.paint = item.selectedPaint;
        cartItem.paintName = this.paintValue.find(x => x.value === item.selectedPaint).name;
      }
      cartItem.finishValue = item.selectedFinish;
      const t = item.availableFinish.find(x => x.value === item.selectedFinish);
      cartItem.finish = t ? t.name : '';
      cartItem.v6FinishCode = t.v6Code;
      cartItem.categoryId = item.categoryId;
      // if selected finish has available sizes then it is mandatory
      if (t.availableSizes && t.availableSizes.length > 0 && t.availableSizes[0].value) {
        if (!item.selectedSize) {
          item.isInavlidSize = true as boolean;
          cartItem.isValid = false;
          return;
        }
        cartItem.size = item.selectedSize;
      }
    }
    if (item.qty < 1) {
      // return error
      item.isInavlidQuantity = true as boolean;
      cartItem.isValid = false;
      return;
    }
    cartItem.quantity = item.qty;
    return cartItem;
  }
  rowItemQuote: any;
  addItemToQuote(item: any) {
    const rowData = this.validateAndPrepareModel(item);
    if (rowData) {
      this.rowItemQuote = rowData;
      this.rowItemQuote.isOpened = true;
      this.rowItemQuote.mode = "item-to-quote";
    }
  }
  receiveData($event) {
    this.rowItemQuote = $event;
  }
  configureItem(item: any) {
    //VALIDATION
    item.isInavlidFinishValue = false as boolean;
    if (item.availableFinish && item.availableFinish.length > 0) {
      if (!item.selectedFinish) {
        item.isInavlidFinishValue = true as boolean;
        return;
      }

      if (item.selectedFinish === '22') {
        if (!item.selectedPaint) {
          item.isEmptyPaint = true as boolean;
          //cartItem.isValid = false;
          return;
        }
      }

    }

    //Actual Code
    let productCode: string = '';
    if (item.selectedFinish) {
      productCode = `${item.itemNumber}-${item.selectedFinish}`;
    } else {
      productCode = item.itemNumber;
    }
    if (item.selectedPaint) {
      this.v6productService.v6ProductPreview.paintCode = item.selectedPaint;
      var tempPaint = this.paintValue.find(r => r.value === item.selectedPaint)
      this.v6productService.v6ProductPreview.paintName = tempPaint.name;
    }
    else {
      //no paint applicable so clear out the paint fields
      this.v6productService.v6ProductPreview.paintCode = "";
      this.v6productService.v6ProductPreview.paintName = "";
    }
    if (this.quoteService && this.quoteService.selectedQuoteHeader && this.quoteService.selectedQuoteHeader.quoteCommonId) {
      this.quoteService.selectedQuoteHeader.quoteCommonId = null; //should not select quote in the Add to Quote popup from here
    }
    const routepath = `/build-and-buy/buildKwikkeyProduct/${productCode}`;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([routepath]); // navigate to same route
    });   
  }
  //#endregion
  //#region right side category & finish filter
  filterDataTableByCategory(event, category: MasterData) {
    const index = this.checkedCat.indexOf(+category.value);
    if (category.checked) {
      if (index < 0) {
        this.checkedCat.push(+category.value);
      }
    } else {
      this.checkedCat.splice(index, 1);
    }
    this.setCategoryFilter();
    this.loadItems();
  }
  filterDataTableByfinish(event, finish: MasterData) {
    //console.log(event, finish);    
    const index = this.checkedFin.indexOf(finish.value);
    if (finish.checked) {
      if (index < 0) {
        this.checkedFin.push(finish.value);
      }
    } else {
      this.checkedFin.splice(index, 1);
    }
    this.setFinishFilters();
    this.loadItems();
  }
  setCategoryFilter() {
    this.priceBookCategories.forEach((el, i) => {
      if (this.checkedCat.indexOf(+el.value) > -1) { el.checked = true; } else { el.checked = false; }
    });
    if (this.checkedCat.length === this.priceBookCategories.length) { this.selectAllCategory = true; }
    else {
      this.selectAllCategory = false;
      if (this.checkedCat.length === 0) { this.checkedCat = [-1] }
    }
  }
  setFinishFilters() {
    this.itemFinishes.forEach((el, i) => {
      if (this.checkedFin.indexOf(el.value) > -1) { el.checked = true; } else { el.checked = false; }
    });
    if (this.itemFinishes.length === this.checkedFin.length) { this.selectAllFinish = true; }
    else {
      this.selectAllFinish = false;
      if (this.checkedFin.length === 0) { this.checkedFin = ["-1"]; }
    }
  }
  changeCategorySelection(category) {
    this.checkedCat = [];
    if (category) {
      this.priceBookCategories.forEach((el, index) => { this.checkedCat.push(+el.value); });
    }
    this.setCategoryFilter();
    // reload grid
    this.loadItems();
  }
  changeFinishSelection(selectAllFinish) {
    this.checkedFin = [];
    if (selectAllFinish) {
      this.itemFinishes.forEach((el, index) => { this.checkedFin.push(el.value); });
    }
    this.setFinishFilters();
    // reload grid
    this.loadItems();
  }

  //#endregion

  //#region Grid row finish/size/paint filters
  handleFinishChange(event, dataItem) {
    const selectedFinish = event.value;
    dataItem.selectedSize = '';
    dataItem.selectedSize = '';
    dataItem.availableSizes = [];
    dataItem.paint = [];
    dataItem.listPriceFormated = '';
    if (selectedFinish == '22') {
      this.showPaint = true;
      dataItem.paint = this.paintValue;
    } else {
      dataItem.selectedPaint = ""; //clearing paint dropdown
      dataItem.isEmptyPaint = false;
    }
    if (selectedFinish) {
      dataItem.availableSizes = event.availableSizes;
      if (dataItem.availableSizes.length == 0) {
        dataItem.listPriceFormated = event.listPrice;
      }
      else if (dataItem.availableSizes.length === 1) {
        dataItem.selectedSize = dataItem.availableSizes[0].value;
        dataItem.listPriceFormated = dataItem.availableSizes[0].listPrice;
      }
    }
    dataItem.selectedFinish = selectedFinish;
  }
  handleExtruionLengthChange(event, dataItem) {
    const selectedSize = event.value;
    dataItem.listPriceFormated = '';
    if (selectedSize) {
      dataItem.listPriceFormated = dataItem.availableSizes.find(
        (elm) => elm.value === selectedSize
      ).listPrice;
    }
    dataItem.selectedSize = selectedSize;
  }

  handleItemQtyChanged(event, dataItem) {
    dataItem.qty = event;
  }

  //#endregion
  //#endregion
  //#region helper methods
  //#endregion
  isCategoryExpanded(expanded: boolean) {
    this.expanded = expanded;
  }

}
